import React from 'react';
import { FormFieldV2 as FormField } from '@/components/custom/erp';

interface DocumentNumberRangeProps {
  fromDocumentNumberName: string;
  toDocumentNumberName: string;
  className?: string;
}

const DocumentNumberRange: React.FC<DocumentNumberRangeProps> = ({
  fromDocumentNumberName,
  toDocumentNumberName,
  className
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <FormField name={fromDocumentNumberName} type='text' className='w-32' />
      <FormField name={toDocumentNumberName} type='text' className='w-32' />
    </div>
  );
};

export default DocumentNumberRange;
